<script setup>
import { computed } from 'vue'

const props = defineProps({
	fields: {
		type: Array,
		required: true,
	},
	items: {
		type: Array,
		default: () => [],
	},
	perPage: {
		type: Number,
		default: undefined,
	},
	currentPage: {
		type: Number,
		default: 1,
	},
	tableClass: {
		type: String,
		default: '',
	},
	theadClass: {
		type: String,
		default: '',
	},
	responsive: {
		type: Boolean,
		default: false,
	},
	primaryKey: {
		type: String,
		default: 'id',
	},
})

const displayedItems = computed(() => {
	if (!props.perPage) return props.items
	const start = (props.currentPage - 1) * props.perPage
	return props.items.slice(start, start + props.perPage)
})

function getFieldValue(item, key) {
	return key.split('.').reduce((value, segment) => value?.[segment], item)
}

function rowKey(item, index) {
	const key = item?.[props.primaryKey]
	return key != null ? key : index
}

function cellSlotName(fieldKey) {
	return `cell(${fieldKey})`
}

function rowContext(item, index, field) {
	return {
		item,
		index,
		field,
		value: getFieldValue(item, field.key),
	}
}
</script>

<template>
	<div :class="{ 'overflow-x-auto': responsive }">
		<table :class="tableClass">
			<thead :class="theadClass">
				<tr>
					<th
						v-for="field in fields"
						:key="field.key"
						:class="field.thClass"
						scope="col"
					>
						{{ field.label }}
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in displayedItems" :key="rowKey(item, index)">
					<td
						v-for="field in fields"
						:key="field.key"
						:class="field.tdClass"
					>
						<slot
							:name="cellSlotName(field.key)"
							v-bind="rowContext(item, index, field)"
						>
							{{ getFieldValue(item, field.key) }}
						</slot>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
